// BulkActions component - Bottom bar for bulk operations
import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import ConfirmDialog from './ConfirmDialog';
import '../styles/BulkActions.css';

interface BulkActionsProps {
  selectedCount: number;
  onDelete: () => Promise<void>;
  onExport: () => void;
  onCancel: () => void;
}

export const BulkActions: React.FC<BulkActionsProps> = ({
  selectedCount,
  onDelete,
  onExport,
  onCancel
}) => {
  const { t } = useLanguage();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await onDelete();
      setShowDeleteConfirm(false);
    } catch (error) {
      console.error('Failed to delete catches:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <div className="bulk-actions">
        <div className="bulk-actions-info">
          <span className="bulk-actions-count">{selectedCount}</span>
          <span className="bulk-actions-text">{t.selected}</span>
        </div>

        <div className="bulk-actions-buttons">
          <button
            className="bulk-action-button bulk-action-delete"
            onClick={() => setShowDeleteConfirm(true)}
            disabled={isDeleting}
          >
            🗑️ {t.delete}
          </button>

          <button
            className="bulk-action-button bulk-action-export"
            onClick={onExport}
            disabled={isDeleting}
          >
            📤 {t.export}
          </button>

          <button
            className="bulk-action-button bulk-action-cancel"
            onClick={onCancel}
            disabled={isDeleting}
          >
            ✕ {t.cancel}
          </button>
        </div>
      </div>

      {showDeleteConfirm && (
        <ConfirmDialog
          isOpen={showDeleteConfirm}
          title={t.delete}
          message={`${t.delete} ${selectedCount} ${selectedCount === 1 ? t.catch : t.catches}?`}
          confirmText={t.delete}
          cancelText={t.cancel}
          onConfirm={handleDelete}
          onCancel={() => setShowDeleteConfirm(false)}
          variant="danger"
        />
      )}
    </>
  );
};
